import { render, staticRenderFns } from "./MdtButtonSelect.vue?vue&type=template&id=5f5d4f44&scoped=true"
import script from "./MdtButtonSelect.vue?vue&type=script&lang=js"
export * from "./MdtButtonSelect.vue?vue&type=script&lang=js"
import style0 from "./MdtButtonSelect.vue?vue&type=style&index=0&id=5f5d4f44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5d4f44",
  null
  
)

export default component.exports